<template>
  <div class="fixed-0 flex" :class="classWrapper ?? positions[_position]">
    <base-dialog-root default-open @update:open="$emit('resolve')">
      <base-dialog-overlay
        v-if="!hideBackdrop"
        class="vf-qpblwh"
        data-test-id="vf-panel-backdrop"
        :style="styleBackdrop"
      />
      <vf-dialog-content
        v-style="{ 'w': { lg: '32.375rem' }, 'max-h': { sm: _size === 'full' ? '100%' : '90%', lg: '100%' } }"
        class="vf-cwbvkg"
        :class="[
          transforms[_position],
          classContent,
          _position === 'bottom' ? 'w-full rounded-t-lg' : 'h-full rounded-lg',
          { [heights[_size]]: ['top', 'bottom'].includes(_position) },
          {
            'bg-white': !variant,
            'bg-white bg-op-90': variant === 'light',
            'bg-brand-8 bg-op-70': variant === 'brand',
            'bg-grey-20 bg-op-70 c-grey-90': variant === 'dark',
          },
        ]"
        :disable-outside-interaction
        :style="styleContent"
      >
        <slot />
      </vf-dialog-content>
    </base-dialog-root>
  </div>
</template>

<script lang="ts" setup>
import type { Emits, Props } from '#brands/components/vf/panel/Panel.vue'

const {
  position = { sm: 'bottom', lg: 'right' },
  size = { sm: 'sm' },
  classWrapper
} = defineProps<Props & { variant?: 'dark' | 'brand' | 'light' }>()

defineEmits<Emits>()

const { $viewport } = useNuxtApp()
const { heights, positions, transforms } = useAppConfig().components.vf.panel

const _position = computed(() => getValueForBreakpoint($viewport.breakpoint, position)!)
const _size = computed(() => getValueForBreakpoint($viewport.breakpoint, size)!)
</script>
